import { API_URL } from "General/APIEndpoints";
import { handleStoreState, CoreStore } from "Stores/RESTStore/CoreStore";
import { action, runInAction, observable, makeObservable } from "mobx";
import { API } from "General/API";
import { projectsDataStore } from "Stores";

export interface AvailableAccessRights extends API_KeyValueData {
  value?: "READONLY" | "WRITE";
}

class ViewAccessRightsStore extends CoreStore {
  groupRights: API_AccessRightsEntry[] = [];
  usersRights: API_AccessRightsEntry[] = [];
  currentViewId: number;

  constructor() {
    super();

    makeObservable(this, {
      groupRights: observable,
      usersRights: observable,
      currentViewId: observable,
      clear: action,
      setViewId: action.bound,
      fetch: action.bound,
      deleteRight: action.bound,
      addRight: action.bound,
    });
  }

  url(id: number) {
    return API_URL.VIEWS.getViewRights(projectsDataStore.projectId, id);
  }

  clear() {
    this.groupRights = [];
    this.usersRights = [];
    this.currentViewId = null;
  }

  @handleStoreState()
  async fetch() {
    try {
      const response: API_AccessRightsEntry[] = await API.getData(
        API_URL.VIEWS.getViewRights(projectsDataStore.projectId, this.currentViewId)
      );
      runInAction(() => {
        const { groupRights, usersRights } = this.processResponse(response);
        this.groupRights = groupRights;
        this.usersRights = usersRights;
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async deleteRight(rightId: number) {
    try {
      await API.deleteData(API_URL.VIEWS.deleteViewRight(projectsDataStore.projectId, this.currentViewId, rightId));
      await this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState()
  async addRight(body: AvailableAccessRights) {
    try {
      await API.newData(API_URL.VIEWS.addViewRight(projectsDataStore.projectId, this.currentViewId), body);
      await this.fetch();
    } catch (error) {
      throw error;
    }
  }

  setViewId(id: number) {
    this.currentViewId = id;
  }

  processResponse = (response: API_AccessRightsEntry[]) => {
    const groupRights: API_AccessRightsEntry[] = [],
      usersRights: API_AccessRightsEntry[] = [];
    response.forEach((item) => {
      item.assigneeId.startsWith("@group") ? groupRights.push(item) : usersRights.push(item);
    });

    return { groupRights, usersRights };
  };
}

export const viewAccessRightsStore = new ViewAccessRightsStore();
